/* CONSUMER */
export const CONSUMER_PRO_DESKTOP = 'pro_desktop'

/* FFs */
export const INVOICE_TRANSMISSION = 'invoices_transmission'
export const DISABLE_IBAN_MODIFICATION = 'disable_iban_modification'
export const DISABLE_SIGNUP_FORM = 'disable_signup_form'
